import React, { Component } from 'react';
import styled from 'styled-components';
import { Parallax } from 'react-scroll-parallax';
import media from 'src/styles/media';

import ScrollAnimation from 'src/components/ScrollAnimation';
import Header from 'src/components/Header';
import Timeline from 'src/components/Timeline';
import NextLine from 'src/components/NextLine';
import RegisterButton from 'src/components/RegisterButton';
import imgHistory from 'src/assets/images/legacy/history.jpg';
import imgCarriage from 'src/assets/images/legacy/history-faded.png';

const timelineData = [
  {
    date: '1861',
    image: require('src/assets/images/legacy/1861-legacy.png'),
    credit: 'Photo Credit: Unknown, NWPF photo no. 3146',
    title: 'The Court House',
    description:
      'The Court House, located next to 618 Carnarvon, is valued as one of George William Grant’s most significant institutional projects; it is one of the most important heritage buildings in New Westminster.',
  },
  {
    date: '1895',
    image: require('src/assets/images/legacy/1895-legacy.png'),
    credit: 'Photo Credit: Unknown, NWPF photo no. 3146',
    title: 'Early Family Portrait',
    description:
      "An early family portrait. Olga, Esther, and Arthur Schilen were the children of early settlers who moved to New Westminster for its growing prosperity. Members of the St. Andrew’s Presbyterian Church, the family's contributions to the city and province are commemorated with a stained-glass window at the St. Andrew’s Presbyterian Church in Victoria.",
  },
  {
    date: '1910',
    image: require('src/assets/images/legacy/1910-legacy.png'),
    credit: 'Photo Credit: Unknown, NWPF photo no. 3146',
    title: 'Cunningham Hardware Co.',
    description:
      'Cunningham Hardware Co. was one of the early stores in New Westminster. Photographs like this were taken to promote the store in newspaper adverts.',
  },
  {
    date: '2020',
    image: require('src/assets/images/neighbourhood/aerial.jpg'),
    title: 'The Future of New Westminster',
    description:
      'With the first community-owned fibre optic network in BC, and multiple planning awards as the city builds for the future, New Westminster is positioned to become a hub of community growth.',
  },
];

class Legacy extends Component {
  render() {
    return (
      <Root>
        <Header
          image={imgHistory}
          smallText="From our"
          largeText="Rich History"
        />
        <Content>
          <Title>Our Legacy</Title>
          <Parallax slowerScrollRate offsetYMin={35} offsetYMax={-5}>
            <MainImage src={imgCarriage} alt="Our Legacy" />
          </Parallax>
          <ScrollAnimation>
            <h2 className="history top">History</h2>
            <h1 className="top">New Westminster</h1>
            <Text>
              An original city in Western Canada, the former capital of BC, the
              region’s economic and transportation epicentre — New Westminster
              is a city of beginnings and a capital of innovation.
            </Text>
            <Timeline data={timelineData} />
            <NextLine text="Next: The Location" link="neighbourhood" />
            <RegisterButton />
          </ScrollAnimation>
        </Content>
      </Root>
    );
  }
}

export default Legacy;

const Root = styled.div`
  overflow: hidden;
`;

const Content = styled.div`
  background: linear-gradient(to bottom, #fff1e5, rgba(255, 255, 255, 1));
  padding: 5% 0 0;
  .history {
    text-align: center;
    font-family: ${({ theme }) => theme.fontHeader};
    color: ${({ theme }) => theme.colorPrimary};
    text-transform: uppercase;
    font-size: 18px;
    font-weight: 500;
  }
  h1 {
    text-transform: uppercase;
  }
  .top {
    position: relative;
    z-index: 10;
  }
`;

const Text = styled.p`
  font-family: ${({ theme }) => theme.fontMain};
  font-size: 18px;
  color: rgba(0, 0, 0, 0.72);
  letter-spacing: 0;
  text-align: center;
  line-height: 24px;
  width: 90%;
  margin: 0 auto 60px;
  padding: 30px 0 37.5px;
  position: relative;
  @media (min-width: ${media.smup}) {
    width: 50%;
  }
  &::after {
    content: '';
    width: 4px;
    height: 50px;
    background-color: ${({ theme }) => theme.colorPrimary};
    transform: translate(-50%, -50%);
    position: absolute;
    bottom: -80px;
    left: 50%;
  }
  &::before {
    content: '';
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colorPrimary};
    transform: translate(-50%, -50%);
    position: absolute;
    top: 100%;
    left: 50%;
  }
`;

const MainImage = styled.img`
  width: 100%;
  margin: 80px auto 0;
  display: block;
  z-index: -1;
  @media (min-width: ${media.smup}) {
    width: 60%;
  }
`;

const Title = styled.h1`
  color: white;
  opacity: 0.82;
  font-family: ${({ theme }) => theme.fontHeader};
  font-size: 48px;
  font-weight: bold;
  position: absolute;
  top: 120vh;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: 0.3s ease;
  @media (min-width: ${media.smup}) {
    font-size: 80px;
  }
  @media (min-width: ${media.mdup}) {
    font-size: 114px;
    top: 130vh;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Legacy.js